import type { FC } from 'react';
import { useRelatedCategories } from '../../../../bff-api/products/useRelatedCategories';
import { ProductsRelatedCategories } from '../../../../components/products-related-categories/ProductsRelatedCategories';
import { useCustomPreferenceOrDefault } from '../../../../utils/api';
import { CustomPreference } from '../../../../utils/api/CustomPreference';
import { BloomreachProductType } from '../../hooks/use-search';

export interface SearchProductsRelatedCategoriesProps {
    productType: BloomreachProductType;
    query?: string;
    className?: string;
}

export const SearchProductsRelatedCategories: FC<SearchProductsRelatedCategoriesProps> = ({
    productType,
    className,
    query,
}) => {
    const isEnabled = useCustomPreferenceOrDefault(
        CustomPreference.ENABLE_RELATED_CATEGORIES_ON_PLP,
        true,
    );
    const isSupportedProductType = [
        BloomreachProductType.culinary,
        BloomreachProductType.hardgood,
    ].includes(productType);
    const apiType = isSupportedProductType ? productType : '';

    const { data = [] } = useRelatedCategories(isEnabled && apiType ? apiType : '', { query });

    if (!isEnabled || !data.length) {
        return null;
    }

    return <ProductsRelatedCategories data={data} className={className} />;
};

SearchProductsRelatedCategories.defaultProps = {
    className: undefined,
    query: undefined,
};
